/**
 * @description: 天工常用媒体ID
 * @return {*}
 */
const TOUTIAO = 10
const GDT = 16
const KUAISHOU = 32
const UC = 6
const BAIDU = 45

export const MEDIAS = {
  TOUTIAO,
  GDT,
  KUAISHOU,
  UC,
  BAIDU
}

/**
 * @description: 媒体版本列表，按广点通、头条的顺序展示
 */
export const SUB_MEDIA_OPTIONS_BY_MEDIA = {
  [GDT]: [
    { id: 1, name: '腾讯v1' },
    { id: 2, name: '腾讯ADA' },
    { id: 3, name: '腾讯v3' }
  ],
  [TOUTIAO]: [
    { id: 2, name: '巨量引擎2.0' },
    { id: 3, name: '巨量智擎版' }
  ]
}

const SUB_MEDIA_OPTION_MEDIA_ORDER = [GDT, TOUTIAO]

export const getSubMediaOptionsByMediaIds = (mediaIds = []) =>
  SUB_MEDIA_OPTION_MEDIA_ORDER.reduce((options, mediaId) => {
    if (!mediaIds.includes(mediaId)) return options

    return options.concat(SUB_MEDIA_OPTIONS_BY_MEDIA[mediaId].map((item) => ({ ...item, mediaId })))
  }, [])

/**
 * @description: 媒体列表
 * @return {*}
 */
export const MEDIAS_LIST = [
  {
    value: TOUTIAO,
    label: '巨量引擎'
  },
  {
    value: GDT,
    label: '腾讯'
  },
  {
    value: KUAISHOU,
    label: '磁力引擎'
  },
  // {
  //   value: UC,
  //   label: '超级汇川'
  // },
  {
    value: BAIDU,
    label: '百度信息流'
  }
]

/**
 * @description: 常用应用平台
 * @return {*}
 */
export const PLATFORM = {
  ANDROID: 1,
  IOS: 2,
  MINI_PROGRAM: 3,
  HARMONY: 5
}
export const PLATFORM_LIST = [
  {
    value: PLATFORM.ANDROID,
    label: '安卓'
  },
  {
    value: PLATFORM.IOS,
    label: 'IOS'
  },
  {
    value: PLATFORM.MINI_PROGRAM,
    label: '小程序'
  },
  {
    value: PLATFORM.HARMONY,
    label: '鸿蒙'
  }
]
